var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck28 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.807 4.10535C25.0249 4.27488 25.0642 4.58902 24.8947 4.80699L10.8947 22.807C10.8066 22.9202 10.6742 22.9901 10.5311 22.9991C10.3879 23.008 10.2479 22.955 10.1464 22.8536L4.14645 16.8536C3.95118 16.6583 3.95118 16.3417 4.14645 16.1465C4.34171 15.9512 4.65829 15.9512 4.85355 16.1465L10.4531 21.746L24.1053 4.19305C24.2749 3.97508 24.589 3.93581 24.807 4.10535Z",
  fill: "currentColor"
})));
export default SvgCheck28;